/* ============================================================
   Featured carousel — prev/next arrow controls.

   The product row is a CSS scroll-snap track (overflow-x:auto), which touch
   devices scroll natively but mouse-only desktops cannot. These buttons drive
   track.scrollBy(), disable at each end, and hide entirely when every product
   already fits (no overflow). Multi-instance + re-inits in the theme editor.
   ============================================================ */
(function () {
  function initSection(section) {
    var track = section.querySelector('.fc__track');
    if (!track || track.dataset.fcNavReady) return;

    var prev = section.querySelector('[data-fc-prev]');
    var next = section.querySelector('[data-fc-next]');
    if (!prev && !next) return;
    track.dataset.fcNavReady = '1';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // How far one click scrolls: a near-full viewport of cards, snapped to a
    // whole number of cards so the snap points line up (no half-card rest).
    function stepDistance() {
      var card = track.querySelector('.fc__card');
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var unit = (card ? card.getBoundingClientRect().width : track.clientWidth * 0.6) + gap;
      if (unit <= 0) return track.clientWidth;
      var perView = Math.max(1, Math.floor(track.clientWidth / unit));
      return unit * Math.max(1, perView - 1);
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * stepDistance(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var overflows = max > 2;
      var x = track.scrollLeft;
      if (prev) {
        prev.hidden = !overflows;
        prev.classList.toggle('is-disabled', x <= 1);
      }
      if (next) {
        next.hidden = !overflows;
        next.classList.toggle('is-disabled', x >= max - 1);
      }
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update); // late-loading images can change scrollWidth

    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.fc').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

